import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const range = (range: Array<number>): ValidatorFn => {
  const key = 'range';

  return (control: AbstractControl): ValidationErrors | null => {
    const value: number = +control.value;

    if (!value) return null;

    if (value < range[0] || value > range[1])
      return {
        [key]: { actualValue: value, requiredValue: range, [key]: true },
      };

    return null;
  };
};
